// removed by extract-text-webpack-plugin
module.exports = {"block":"_2S0ZZMEWWFMVL_OtbCfdT5","link":"_2Af2oyFF3xhnyKCGdsUMO5","text":"pHG7nnuHwymb8hqYCT-vL","link-container":"_1HFFgCiAas87Wn3UnLdBpc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DidntFindAnswer/DidntFindAnswer.module.scss
// module id = 748
// module chunks = 0